import { injectable, interfaces } from 'inversify';
import { IObservableArray, makeObservable, observable } from 'mobx';
import { IBaseNotification } from '../models/notification.model';

export interface INotificationsStore {
  notifications: IObservableArray<IBaseNotification>;
}

export namespace INotificationsStore {
  export const $: interfaces.ServiceIdentifier<INotificationsStore> = Symbol('NOTIFICATION_STORE');
}

@injectable()
export class NotificationsStore implements INotificationsStore {
  notifications: IObservableArray<IBaseNotification> = observable.array([]);

  constructor() {
    makeObservable(this, {
      notifications: observable,
    });
  }
}
